import { linko } from "@shared/linko";
import type {
  StatisticsGeographicInsightsResult,
  StatisticsQueryFilters,
} from "./types";

type StatisticsQueriesGeographicInsights = {
  getGeographicInsights: (
    body: StatisticsQueryFilters,
  ) => Promise<{ data: StatisticsGeographicInsightsResult }>;
};

export async function fetchStatisticsGeographicInsights(
  body: StatisticsQueryFilters,
): Promise<StatisticsGeographicInsightsResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsQueriesGeographicInsights;
  const { data } = await queries.getGeographicInsights(body);
  return data;
}
